// Field + preset config for the Vend Requests FilterBuilder.
//
// Only these columns are exposed. `id` is deliberately excluded: the server
// reserves it for the keyset cursor, so a client `id` condition would be
// silently overwritten. The serializer (serializeWhere.js) enforces the same
// allow-list defensively.

export const REQUEST_STATUSES = [
  'PENDING',
  'FAILED',
  'SUCCESSFUL',
  'CANCELED',
  'DEBT_OWED',
];

// Relative-date literals the API substitutes server-side (sqlize-query). Offered
// as presets on datetime fields so users can filter e.g. "last 24 hours" without
// picking an absolute timestamp. Sent verbatim as the condition value.
export const DATE_PRESETS = [
  { value: '@NOW', label: 'Now' },
  { value: '@LAST_10_MINUTES', label: 'Last 10 minutes' },
  { value: '@LAST_24_HOURS', label: 'Last 24 hours' },
  { value: '@TODAY', label: 'Today' },
  { value: '@YESTERDAY', label: 'Yesterday' },
  { value: '@THIS_WEEK', label: 'This week' },
  { value: '@LAST_WEEK', label: 'Last week' },
  { value: '@THIS_MONTH', label: 'This month' },
  { value: '@LAST_MONTH', label: 'Last month' },
];

// Reuses the shared FilterBuilder component. `presets` on the date fields is an
// optional, backward-compatible extension read only by FilterBuilder's value
// input (see FilterBuilder.js) — other screens that omit it are unaffected.
export const REQUEST_FIELDS = [
  { key: 'reference', label: 'Reference', type: 'string' },
  { key: 'gateway_ref', label: 'Gateway Ref', type: 'string' },
  { key: 'customer_ref', label: 'Customer Ref', type: 'string' },
  { key: 'amount', label: 'Amount', type: 'number' },
  { key: 'service', label: 'Service', type: 'string' },
  { key: 'plan', label: 'Plan', type: 'string' },
  { key: 'gateway', label: 'Gateway', type: 'string' },
  { key: 'status', label: 'Status', type: 'enum', options: REQUEST_STATUSES },
  { key: 'customer_id', label: 'Customer ID', type: 'number' },
  { key: 'agent_id', label: 'Agent ID', type: 'number' },
  { key: 'order_id', label: 'Order ID', type: 'number' },
  { key: 'created_at', label: 'Created', type: 'date', presets: DATE_PRESETS },
  { key: 'updated_at', label: 'Updated', type: 'date', presets: DATE_PRESETS },
];

// Column allow-list for the serializer — never contains `id`.
export const ALLOWED_FIELDS = REQUEST_FIELDS.map((f) => f.key);
